import { useAppDispatch } from '@/Application/Hooks/Redux';
import { updateCart } from '@/modules/cart/infrastructure/CartReduxRepository/slices/CartSlice';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import { lineItemDtotoCartLineItem } from '@/modules/cart/infrastructure/mappers/httpCartDtoToCart';
import {
  billingQueryKeys,
  getBillingOrderId
} from '@/modules/perseo-billing/services/api/billing/queries';
import { useQuery } from '@/modules/perseo-billing/services/cache';

import type { IOrder } from '../interfaces/src/bff-web/billing/interfaces/orderV2';

export const useBillingGetOrderStatus = ({
  orderId
}: Record<string, string | null>) => {
  const dispatch = useAppDispatch();
  const queryResult = useQuery<IOrder>(
    billingQueryKeys.orderId,
    () => getBillingOrderId({ orderId }),
    {
      useErrorBoundary: false,
      onSuccess: (data: IOrder) => {
        const { lineItems: newLineItems } = data || [];
        const lineItems = newLineItems.map((lineItem) =>
          lineItemDtotoCartLineItem(lineItem, data as unknown as HttpCartDto)
        );
        dispatch(updateCart({ lineItems, id: data?.id }));
      }
    }
  );
  return queryResult;
};
